import { Component, OnInit } from '@angular/core';
import { UserService, CampusWard, AcademicSession, WardGroupType, CampusWardsDataService, HousingDataService, SortService } from '../../shared';
import { LeaderComponent } from '../leader.component';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
  templateUrl: './ward-group-assignments-lookup.component.html',
  styleUrls: ['./ward-group-assignments-lookup.component.scss']
})
export class WardGroupAssignmentsLookupComponent extends LeaderComponent implements OnInit {
  ward: CampusWard;
  loading = false;
  loadingError = false;

  semesters: AcademicSession[];
  selectedAcademicSession: AcademicSession;
  groupTypes: WardGroupType[];
  selectedGroupType: WardGroupType;

  constructor(
    protected userService: UserService,
    protected dialog: MatDialog,
    private wardService: CampusWardsDataService,
    private housingService: HousingDataService,
    private sorter: SortService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    super(userService, dialog);
  }

  ngOnInit() {
    super.ngOnInit();

    // TODO if not proxied, load the ward details that the leader is in charge of
    if (this.isWardLeader()) {
      this.ward = this.getWard();
    }

    this.loadData();
  }

  navigateToLoad() {
    if (this.selectedAcademicSession && this.selectedGroupType) {
      this.router.navigate(['./', this.selectedAcademicSession.sessionNumber],
        { relativeTo: this.route,
          queryParams: {
            groupTypeId: this.selectedGroupType.campusWardGroupTypeId,
            year: this.selectedAcademicSession.year,
            session: this.selectedAcademicSession.code
         } });
    }
  }

  /**
   * Loads the data we need to function: semesters and group types.
   */
  private loadData() {
    this.loading = true;
    forkJoin(this.wardService.getWardGroupTypes(), this.housingService.getAcademicSessions())
      .pipe(
        finalize(() => (this.loading = false))
      )
      .subscribe(
        ([types, semesters]) => {
          this.groupTypes = types;
          this.groupTypes.sort(this.sorter.sortWardGroupTypesAsc);

          this.semesters = semesters;
          this.semesters.sort(this.sorter.sortAcademicSessionsAsc);

          if (this.semesters.length > 0) {
            this.selectedAcademicSession = this.semesters[0];
          }
        },
        error => {
          this.loadingError = true;
        }
      );
  }
}
